import React from 'react';
import HomePage from './pages/HomePage';
import './assets/styles/responsive.css';

function App() {
  return <HomePage />;
}

export default App;
